import { CACHE_TTL, Nullable } from '@ps/utils';
import {
  Company,
  CompanyDetail,
  CompanyFormMode,
  CompanyOperatorUser,
  Currency,
} from '../models/company.model';
import { SupplierSettingsForm } from '../models/company-form.model';
import { SupplierSegmentation } from '../models/segment-parent.model';
import { BuyerConfigSettingsForm } from '../models/company-buyer-config.model';

export const COMPANIES_CACHE_TTL = CACHE_TTL.SESSION;

export interface CompanyPageCacheEntry {
  companies: Company[];
  totalCount: number;
  cachedAt: number;
}

export interface CompanyState {
  companies: Company[];
  totalCount: number;
  currentPage: number;
  limit: Nullable<number>;
  search: string;
  pageCache: Record<number, CompanyPageCacheEntry>;
  mode: CompanyFormMode;
  selectedCompany: Nullable<CompanyDetail>;
  segmentation: Nullable<SupplierSegmentation>;
  supplierSettings: Nullable<SupplierSettingsForm>;
  buyerConfigSettings: Nullable<BuyerConfigSettingsForm>;
  isLoadingDetail: boolean;
  isLoadingSupplierSettings: boolean;
  isSavingSupplierSettings: boolean;
  isLoadingBuyerConfigSettings: boolean;
  isSavingBuyerConfigSettings: boolean;
  isResettingBuyerConfigSettings: boolean;
  isLoadingSegmentation: boolean;
  isSavingSegmentation: boolean;
  isTogglingSegmentation: boolean;
  isLoading: boolean;
  isSaving: boolean;
  isDeleting: boolean;
  currencies: Currency[];
  operatorUsers: CompanyOperatorUser[];
  error: Nullable<string>;
  isRegisteringWebhook: boolean;
  isUnsubscribingWebhook: boolean;
}
